import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-card-header',
  templateUrl: './card-header.component.html',
  styleUrls: ['./card-header.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class CardHeaderComponent {
  @Input() isLoading: boolean = false;
  @Input() skeletonStyles: any = {};
}
